(function () {
  function setHeightImageThumb() {
    const productMainImage = document.querySelector(
      ".js-product-gallery .gallery-cell"
    );
    if (productMainImage) {
      const productThumb = document.querySelector(
        ".product-gallery__thumbnails"
      );
      heightMainImage = productMainImage.offsetHeight;
      productThumb.setAttribute(
        "style",
        `--heightMainImage: ${heightMainImage}px`
      );
    }
  }

  function updateDeliveryDays() {
    const deliverDayElement = document.querySelector(".js-deliver-day");

    const dropdownBtn = document.querySelector(".js-product-deliver");
    const dropdownValue = document.querySelector(".js-product-deliver span");
    const dropdownContent = document.querySelector(
      ".product-deliver__dropdown"
    );
    const dropdownItems = document.querySelectorAll(
      ".product-deliver__dropdown-item"
    );
    const itemActive = document.querySelector(
      ".product-deliver__dropdown-item.active"
    );

    if (itemActive) {
      deliverDayElement.textContent = itemActive.getAttribute("data-value");
    }

    dropdownBtn.addEventListener("click", function () {
      dropdownContent
        .closest(".product-deliver__deliver")
        .classList.toggle("show");
    });

    dropdownItems.forEach((item) => {
      item.addEventListener("click", function () {
        dropdownValue.textContent = this.textContent;
        dropdownContent
          .closest(".product-deliver__deliver")
          .classList.remove("show");
        deliverDayElement.textContent = this.getAttribute("data-value");

        if (itemActive) {
          document
            .querySelector(".product-deliver__dropdown-item.active")
            .classList.remove("active");
        }
        item.classList.add("active");
      });
    });

    window.addEventListener("click", (event) => {
      if (!event.target.matches(".js-product-deliver")) {
        dropdownContent
          .closest(".product-deliver__deliver")
          .classList.remove("show");
      }
    });
  }

  function initializeProductTabs() {
    const tabs = document.querySelectorAll(".js-tab-title");
    const tabContents = document.querySelectorAll(".js-tab-content");
    const collapsibleTitle = document.querySelectorAll(
      ".collapsible-tab-title"
    );

    if (!tabs) return;

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("tab-active"));
        tab.classList.add("tab-active");

        tabContents.forEach((content) =>
          content.classList.remove("tab-content-active")
        );
        document
          .getElementById(tab.getAttribute("data-tab"))
          .classList.add("tab-content-active");
      });
    });

    collapsibleTitle.forEach((item) => {
      item.addEventListener("click", () => {
        tabContents.forEach((tabContent) => {
          if (tabContent !== item.closest(".js-tab-content")) {
            tabContent.classList.remove("active");
          }
        });

        const currentTab = item.closest(".js-tab-content");
        currentTab.classList.toggle("active");
      });
    });
  }

  function initShowMore() {
    const descHeight = document.querySelector(
      "#product-description .collapsible-tab-content"
    ).offsetHeight;
    const btnShowmore = document.querySelector(".js-btn-read-more");
    if (btnShowmore) {
      btnShowmore.addEventListener("click", function () {
        btnShowmore
          .closest(".collapsible-tab-content")
          .classList.toggle("open");
      });

      if (descHeight > 431) {
        document.querySelector(".collapsible-tab-action").style.display =
          "flex";
      }
    }
  }

  function initSizeChart() {
    const sizeChartElement = document.querySelector(".product-size-chart");
    const spans = document.querySelectorAll(
      ".selector-wrapper.bcpo-buttons .bcpo-title"
    );
    if (spans) {
      spans.forEach(function (span) {
        if (/size/i.test(span.textContent.trim())) {
          const label = span.closest("label");
          label.classList.add("selector-size");
          if (label) {
            label.appendChild(sizeChartElement);
          }
        }
      });
    }
  }

  function init() {
    setHeightImageThumb();
    updateDeliveryDays();
    initializeProductTabs();
    initShowMore();
  }

  document.addEventListener("DOMContentLoaded", init);

  window.addEventListener("load", function () {
    setTimeout(function () {
      initSizeChart();
    }, 800);
  });

  window.onresize = () => {
    setHeightImageThumb();
  };

  document.addEventListener("shopify:section:load", () => {
    initializeProductTabs();
  });

  window.updateDeliveryDays = updateDeliveryDays;
})();

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

window.addEventListener("load", () => {
  document
    .querySelectorAll(".price-ui--loading")
    .forEach((el) => el.classList.remove("price-ui--loading"));
});
